import React from 'react';
import { connect } from 'react-redux';

import { selectHasAuthenticatedAccessScope } from 'selectors/scopes';
import { convertFullTimeToTrimTime } from 'utilities/trimming';

import TimelineEmoji from './timeline-emoji';

import styles from './styles.module.less';

class EmojiTimeline extends React.Component {
  constructor(props) {
    super(props);

    let toolbarWidth = 0;

    // find out how big the toolbar is for bumping up emoji above it
    try {
      toolbarWidth = window.top.document.getElementsByClassName(
        'export-bar-emoji-bar-container'
      )[0].clientWidth;
    } catch (e) {
      // no worries if it didn't work
    }

    this.state = { toolbarWidth };
  }

  render() {
    const {
      reactions,
      localReactions,
      animateReactions,
      controlBarExpanded,
      containerDimensions,
      currentTime,
      duration,
      reactionName,
      trimRanges = [],
      timelineIconClass,
    } = this.props;

    const allReactions = reactions.concat(
      localReactions.map(r => {
        // Anon users must type a name on local reactions
        // TODO: Rewrite anon username code so it's saved in store
        return {
          ...r,
          can_delete: r.id ? true : false, // only allow deletion of saved reactions
          username: reactionName || 'anonymous',
          playSelectionAnimation: true,
        };
      })
    );

    const currentTimeInMs = currentTime * 1000;

    const timelineEmojis = () =>
      allReactions.map(reaction => {
        const time = convertFullTimeToTrimTime(reaction.time, trimRanges);

        // Remove reactions that have been trimmed out
        if (isNaN(time)) {
          return null;
        }

        let rise = 0;

        // pop up emoji higher than toolbar only if it's not expanded
        if (this.state.toolbarWidth && !controlBarExpanded) {
          const width = containerDimensions.width;
          const start = width / 2 - this.state.toolbarWidth / 2;
          const end = start + this.state.toolbarWidth;
          const currentX = (currentTime / duration) * width;

          if (currentX >= start && currentX <= end) {
            rise = 10;
          }
        }

        return (
          (currentTimeInMs >= time || controlBarExpanded) && (
            <TimelineEmoji
              key={reaction.localId || reaction.id}
              id={reaction.id}
              playSelectionAnimation={
                animateReactions.indexOf(reaction.localId) > -1
              }
              containerDimensions={containerDimensions}
              rise={rise}
              type={reaction.type}
              forceShow={controlBarExpanded}
              time={time}
              username={reaction.username}
              showDelete={reaction.can_delete}
              duration={duration * 1000}
              iconClass={timelineIconClass}
            />
          )
        );
      });

    return (
      <div className={styles.emojiTimeline} ref={me => (this.timeline = me)}>
        {timelineEmojis()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: {
      current: { first_name: firstName },
    },
    share_video: { anonymousUsername },
  } = state;

  const trimRanges =
    state.video_player.video.processing_information.trim_ranges;
  const hasAuthenticatedAccess = selectHasAuthenticatedAccessScope(state);
  const reactionName = hasAuthenticatedAccess
    ? firstName || anonymousUsername
    : anonymousUsername;

  return {
    reactionName,
    trimRanges,
  };
};

export default connect(mapStateToProps)(EmojiTimeline);
